(() => {
  if (window.cincinUI) return;
  let activeDialog, opener, previousOverflow, placeholder;
  function close() {
    if (!activeDialog) return;
    activeDialog.style.display = 'none';
    placeholder?.replaceWith(activeDialog);
    placeholder = null;
    activeDialog = null;
    if (typeof removeTrapFocus === 'function') removeTrapFocus(opener);
    else opener?.focus();
    document.body.style.overflow = previousOverflow;
  }
  function open(dialog, trigger) {
    if (!dialog) return;
    close();
    opener = trigger || document.activeElement;
    activeDialog = dialog;
    placeholder = document.createComment('dialog');
    dialog.before(placeholder);
    document.body.append(dialog);
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.style.display = 'block';
    if (typeof trapFocus === 'function') trapFocus(dialog);
    else dialog.focus();
  }
  window.cincinUI = { open, close };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cincin-open], .header__icon--account');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.cincinOpen || 'loginModal');
      if (dialog) { event.preventDefault(); open(dialog, trigger); }
    }
    if (event.target === activeDialog || event.target.closest('[data-cincin-close], .close-mini-cart, .close-nappi, .lightbox .close')) close();
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && activeDialog) { event.preventDefault(); close(); }
  });
  function initialize(scope = document) {
    scope.querySelectorAll('[data-cincin-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('.carousel-track, .ulko-osa');
      const previous = carousel.querySelector('.carousel-button.prev');
      const next = carousel.querySelector('.carousel-button.next');
      if (!track || !previous || !next) return;
      const update = () => {
        previous.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1;
      };
      const move = direction => track.scrollBy({ left: direction * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, { passive: true });
      const resize = new ResizeObserver(update);
      resize.observe(track);
      carousel.cincinCleanup = () => resize.disconnect();
      update();
    });
    scope.querySelectorAll('[data-cincin-pagination]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const items = [...section.querySelectorAll('.collection-list__item')];
      const pagination = section.querySelector('.pagination');
      if (!pagination || items.length <= 16) return;
      function show(page) {
        items.forEach((item, index) => item.hidden = index < page * 16 || index >= (page + 1) * 16);
        [...pagination.children].forEach((button, index) => {
          button.classList.toggle('active', index === page);
          if (index === page) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        });
      }
      for (let page = 0; page < Math.ceil(items.length / 16); page++) {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = page + 1;
        button.addEventListener('click', () => show(page));
        pagination.append(button);
      }
      show(0);
    });
    scope.querySelectorAll('.wave-text-svg').forEach(svg => {
      if (svg.dataset.ready) return;
      svg.dataset.ready = 'true';
      const text = svg.querySelector('.wave-text-path');
      if (!text) return;
      if (svg.dataset.pathType === 'straight') svg.querySelector('path')?.setAttribute('d', 'M -400 50 L 2400 50');
      let frame, previous, offset = 0, hovered = false;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      function animate(time) {
        if (!svg.isConnected) return;
        if (!hovered && !reduce.matches && !document.hidden && previous !== undefined) {
          offset = (offset + Math.min(time - previous, 100) / 435) % 100;
          text.setAttribute('startOffset', `${-offset}%`);
        }
        previous = time;
        frame = requestAnimationFrame(animate);
      }
      svg.addEventListener('mouseenter', () => hovered = true);
      svg.addEventListener('mouseleave', () => hovered = false);
      frame = requestAnimationFrame(animate);
      svg.cincinCleanup = () => cancelAnimationFrame(frame);
    });
    scope.querySelectorAll('.two-column-section').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const lightbox = section.querySelector('.lightbox');
      const image = lightbox?.querySelector('img');
      const photos = [...section.querySelectorAll('.open-lightbox')];
      if (!lightbox || !image || !photos.length) return;
      let current = 0;
      function show(index) {
        current = (index + photos.length) % photos.length;
        image.src = photos[current].dataset.large || photos[current].src;
        image.alt = photos[current].alt;
      }
      photos.forEach((photo, index) => {
        const activate = () => { show(index); open(lightbox, photo); };
        photo.addEventListener('click', activate);
        photo.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); activate(); }
        });
      });
      lightbox.querySelector('.prev')?.addEventListener('click', () => show(current - 1));
      lightbox.querySelector('.next')?.addEventListener('click', () => show(current + 1));
      lightbox.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
      });
    });
    const result = scope.querySelector('[data-cincin-form-result]');
    if (result) open(result.closest('[role="dialog"]'));
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-ready]').forEach(element => element.cincinCleanup?.());
    if (activeDialog && (event.target.contains(activeDialog) || event.target.contains(placeholder))) close();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
})();
